module.exports = __webpack_public_path__ + "img/social.7c0434e1.svg";